import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    color?: string;
};

const CarIcon = ({ width = 51, height = 42, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 51 42" fill="none" {...props}>
            <path d="M39.5752 0.00488281C41.8839 0.107758 43.8349 1.78748 44.2646 4.07812L46.125 14H46.5C48.7091 14 50.5 15.7909 50.5 18V31C50.5 33.2091 48.7091 35 46.5 35H45.5V40C45.5 41.1046 44.6046 42 43.5 42C42.3954 42 41.5 41.1046 41.5 40V35H9.5V40C9.5 41.1046 8.60457 42 7.5 42C6.39543 42 5.5 41.1046 5.5 40V35H4.5L4.29395 34.9951C2.2488 34.8913 0.608652 33.2512 0.504883 31.2061L0.5 31V18C0.5 15.86 2.18056 14.1121 4.29395 14.0049L4.5 14H4.875L6.73535 4.07812C7.17892 1.71356 9.24358 0.000103291 11.6494 0H39.3506L39.5752 0.00488281ZM4.5 16C3.46435 16 2.613 16.7872 2.51074 17.7959L2.5 18V31C2.5 32.1046 3.39543 33 4.5 33H46.5C47.6046 33 48.5 32.1046 48.5 31V18C48.5 16.9643 47.7128 16.113 46.7041 16.0107L46.5 16H4.5ZM11 21C12.3811 21 13.5 22.1189 13.5 23.5C13.5 24.8811 12.3811 26 11 26C9.61888 26 8.5 24.8811 8.5 23.5C8.5 22.1189 9.61888 21 11 21ZM40 21C41.3811 21 42.5 22.1189 42.5 23.5C42.5 24.8811 41.3811 26 40 26C38.6189 26 37.5 24.8811 37.5 23.5C37.5 22.1189 38.6189 21 40 21ZM11.6494 2C10.2059 2.0001 8.96721 3.02842 8.70117 4.44727L6.91016 14H44.0898L42.2988 4.44727C42.0328 3.02842 40.7941 2.0001 39.3506 2H11.6494Z" fill={color} />
        </svg>
        
    );
};

export default CarIcon;
